export default {"src":"/_next/static/media/app-store-badge.0a2c7b94.svg","height":40,"width":120};